export const APPNAME = "Waifusion";
